const getQueryParamValue = (paramName: string, url = window.location.href) => {
  const name = paramName.replace(/[[]]/g, '\\$&');

  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(url);

  if (!results) {
    return '';
  }
  if (!results[2]) {
    return '';
  }

  const result = decodeURIComponent(results[2].replace(/\+/g, ' '));

  if (result.indexOf('%') > -1) {
    return decodeURIComponent(result);
  }

  return result;
};

export default getQueryParamValue;
